module.exports = __webpack_public_path__ + "3f9e1f1a208dffb9f92a9e7c09b0d29e.fbx";